module.exports = __webpack_public_path__ + "img/t1-2.84afed97.png";